
export default "/assets/simple-analytics.f823f2b0.svg"